import * as React from 'react';

import styles from './styles.module.scss';

interface OwnProps {
	children: React.ReactNode;
	columnStart: number;
	colSpan: number;
	isFirstCol: boolean;
	isLastCol: boolean;
	isLeaf: boolean;
	needsTopBorder: boolean;
	rowStart?: number;
	rowEnd?: number;
	needsRightBorder: boolean;
	style?: React.CSSProperties;
	needsFixedRightBorder?: boolean;
}

type Props = OwnProps;

function HeaderGridCell(props: Props) {
	const {
		children,
		columnStart,
		colSpan,
		isFirstCol,
		isLastCol,
		isLeaf,
		needsTopBorder,
		rowStart,
		rowEnd,
		needsRightBorder,
		needsFixedRightBorder = false,
		style,
	} = props;

	const className = [
		styles['simple-table__header-grid-cell'],
		isFirstCol ? styles['simple-table__header-grid-cell--first-col'] : '',
		isLastCol ? styles['simple-table__header-grid-cell--last-col'] : '',
		isLeaf ? styles['simple-table__header-grid-cell--leaf'] : styles['simple-table__header-grid-cell--group'],
		needsRightBorder ? styles['simple-table__header-grid-cell--needs-right-border'] : '',
		needsTopBorder ? styles['simple-table__header-grid-cell--needs-top-border'] : '',
	].filter(Boolean).join(' ');

	return (
		<div
			className={className}
			role="columnheader"
			style={{
				gridColumn: `${columnStart} / span ${colSpan}`,
				...(rowStart !== undefined && rowEnd !== undefined ? { gridRow: `${rowStart} / ${rowEnd}` } : {}),
				...style,
				...(needsFixedRightBorder ? { borderRight: '1px solid #C5C8CB' } : {}),
			}}
		>
			{children}
		</div>
	);
}

export default React.memo(HeaderGridCell);
